import React, { useContext, useEffect, useRef, useState } from "react";
import "./Navbar.css";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import CloseIcon from "@material-ui/icons/Close";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Registration from "../../Registration/Registration";
import logo from "../../../Image/logo.png";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import { AuthContext } from "../../../context/AuthContext";
import AccountCircle from "@material-ui/icons/AccountCircle";
import Modal from "../../Modal/Modal";
import LoginModal from "../../Modal/LoginModal";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    position: "fixed",
    left: 0,
    top: 0,
    width: "100%",
    zIndex: 100,
  },
  navColor: {
    backgroundColor: "#DCE5F1",
    color: "#222",
    boxShadow: "none",
    height: "100% !important",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    paddingLeft: "20px",
  },
  subTitle: {
    fontSize: 14,
    fontWeight: 700,
  },
}));

const Navbar = ({ isShaw, setIsShaw }) => {
  const classes = useStyles();
  const [auth, setAuth] = React.useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [afterSubmitModalOpen, setAfterSubmitModalOpen] = useState(false);

  // const [signUpmodel, setSignUpmodel] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const ref = useRef(null);
  const open = Boolean(anchorEl);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, dispatch } = useContext(AuthContext);
  const splitLocaion = location?.pathname?.split("/");
  console.log(splitLocaion);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleModelOpenLogin = () => {
    if (!user) {
      setLoginModalOpen(true);
    } else {
      navigate("/request-a-quote");
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsShaw(true);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleLogout = () => {
    setAnchorEl(null);
    try {
      dispatch({ type: "LOGOUT" });
      localStorage.removeItem("user");
      navigate("/");
      window.location.reload();
    } catch (error) {
      dispatch({ type: "LOGIN_FAILURE", payload: error.response.data });
    }
  };
  const handleDashboardLogin = () => {
    if (!user) {
      setLoginModalOpen(true);
    } else {
      navigate("/dashboard");
    }
  };
  return (
    <div className={classes.root} ref={ref}>
      {modalOpen && (
        <Modal
          setModalOpen={setModalOpen}
          setAfterSubmitModalOpen={setAfterSubmitModalOpen}
        />
      )}
      {loginModalOpen && (
        <LoginModal
          setLoginModalOpen={setLoginModalOpen}
          setAfterSubmitModalOpen={setAfterSubmitModalOpen}
          setModalOpen={setModalOpen}
        />
      )}
      <div className="toggleBtn">
        <>
          <Typography variant="h6" className={classes.title}>
            <Link to="/" className="logo2">
              <img src={logo} alt="" />
            </Link>
          </Typography>
        </>
        {isShaw ? (
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
            onClick={() => setIsShaw(false)}
          >
            <MenuIcon />
          </IconButton>
        ) : (
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
            onClick={() => setIsShaw(true)}
          >
            <CloseIcon />
          </IconButton>
        )}
      </div>
      <div className="headerNav">
        <AppBar
          position="static"
          className={
            !isShaw ? `${classes.navColor} ` : "MuiAppBar-colorPrimary"
          }
        >
          <Toolbar>
            <Typography variant="h6" className="logo">
              <Link to="/">
                <img src={logo} alt="" />
              </Link>
            </Typography>
            {auth && (
              <div
                className={
                  !isShaw ? "headerMenu" : "headerMenu dashBoardMenuBefore"
                }
              >
                {!user && (
                  <Typography variant="h6" className="menuLink">
                    <Link
                      className={classes.subTitle}
                      onClick={() => setLoginModalOpen(true)}
                    >
                      <IconButton color="inherit">
                        <PersonOutlineOutlinedIcon />
                        <button type="button">Sign In</button>
                      </IconButton>
                    </Link>
                    <IconButton color="inherit"> Or</IconButton>

                    <Link
                      className={classes.subTitle}
                      onClick={() => setModalOpen(true)}
                    >
                      <IconButton color="inherit">
                        <button type="button">Registration</button>
                      </IconButton>
                      {/* <Registration
                        modelOpen={modelOpen}
                        setModelOpen={setModelOpen}
                        handleModelOpen={handleModelOpen}
                        handleModelClose={handleModelClose}
                      /> */}
                    </Link>
                  </Typography>
                )}
                {user && (
                  <Typography variant="h6" className={classes.subTitle}>
                    <div>
                      <IconButton
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="inherit"
                        className="userIconNav"
                      >
                        <AccountCircle />
                        <Link className={classes.subTitle}>
                          {" "}
                          {user?.detail?.companyName}
                        </Link>
                      </IconButton>
                      <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        open={open}
                        onClose={handleClose}
                      >
                        <MenuItem onClick={handleClose}>Profile</MenuItem>
                        <MenuItem onClick={handleLogout}>Logout</MenuItem>
                      </Menu>
                    </div>
                  </Typography>
                )}
                {splitLocaion[1] !== "request-a-quote" && (
                  <>
                    {splitLocaion !== "/" ? (
                      <Typography variant="h6" className={classes.subTitle}>
                        <IconButton
                          color="inherit"
                          className="navLine custom_link_style"
                          onClick={handleModelOpenLogin}
                        >
                          Request a Quote
                        </IconButton>
                      </Typography>
                    ) : (
                      <Typography variant="h6" className={classes.subTitle}>
                        <IconButton
                          color="inherit"
                          className=" custom_link_style"
                          onClick={handleModelOpenLogin}
                        >
                          Request a Quote
                        </IconButton>
                      </Typography>
                    )}
                  </>
                )}

                <Typography variant="h6" className={classes.subTitle}>
                  <IconButton
                    color="inherit"
                    className=""
                    onClick={handleDashboardLogin}
                  >
                    Dashboard
                  </IconButton>
                </Typography>
              </div>
            )}
          </Toolbar>
        </AppBar>
      </div>
    </div>
  );
};

export default Navbar;
